import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { forms as Forms } from '@breezeway/brzw-components';

import './form_control_boolean_switch.scss';

const FormControlBooleanSwitch = ({
  input: { onChange, value, name },
  id,
  labelText,
  labelClassName,
  options,
  copy,
}) => (
  <div className="form-control-boolean-switch">
    <Forms.Label
      text={labelText}
      className={classnames('form-control-boolean-switch__label', labelClassName)}
    />
    <div className="form-control-boolean-switch__wrapper">
      <span className="text form-control-boolean-switch__placeholder">{copy}</span>
      <div className="form-control-boolean-switch__switch-wrapper">
        <Forms.BooleanSwitch
          id={id}
          onChange={onChange}
          options={options}
          value={value}
          name={name}
        />
      </div>
    </div>
  </div>
);

FormControlBooleanSwitch.propTypes = {
  copy: PropTypes.string,
  id: PropTypes.string,
  input: PropTypes.shape({}),
  labelText: PropTypes.string,
  labelClassName: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({})),
};

FormControlBooleanSwitch.defaultProps = {
  copy: '',
  options: [],
  labelClassName: '',
  input: {
    value: false,
  },
};

export default FormControlBooleanSwitch;
